export default __webpack_public_path__ + "static/media/messages-icon.40308618.svg";